/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */

import axios from "axios";
import "@/scripts/jfp";

// TODO: Figure out "global" imports for things like above?
// Also, should i export/import in way so that accessing looks like $this->publisherBase.instanceId etc, to make it more clear where things are coming from at all times?

export default {
  props: {
    publisherAccountId: {
      type: [Number, String],
      required: true
    },
    componentPlacement: {
      type: [Number, String],
      default: "undefined"
    },
    componentTheme: {
      type: String,
      default: "default"
    },
    channelOne: {
      type: [Number, String],
      default: ""
    },
    channelTwo: {
      type: [Number, String],
      default: ""
    },
    channelThree: {
      type: [Number, String],
      default: ""
    },
    disableEventsTracking: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      id: 0,
      instanceId: 0,
      removeFromDOM: false,
      shadowDOM: null,
      domElement: null,
      publisherEventData: {},
      subdomain: window.location.hostname,
      domain: window.location.hostname.split(".").slice(-2).join("."),
      domainName: window.location.hostname.split(".").slice(-2)[0],
      urlParams: new URLSearchParams(window.location.search),
      // publisherAccount: {},
      visitorLocation: {
        city: "",
        state: "",
        postalCode: "",
        formatted: "Nationwide"
      }
    };
  },
  computed: {
    themeClass() {
      return "--theme-" + this.componentTheme;
    }
  },
  async mounted() { // Due to async nature, "mounted" is reserved for PublisherBase. Ie, "mounted" should not be used in other mixins/extensions or components.

    if(!this.id) {
      console.error("Publisher Component missing 'id'.");
      this.removeFromDOM = true;
      return;
    }

    this.instanceId = this.generateInstanceId();

    // Wait while we verify the publisher component usage by authenticating our publisher
    await this.verifyComponentUsage()
      .then(() => {

        this.injectRobotoStylesheet();

        this.publisherEventData = {
          publisher_account_id: this.publisherAccountId,
          publisher_component_id: this.id,
          publisher_component_placement: this.componentPlacement,
          publisher_channel_1: this.channelOne,
          publisher_channel_2: this.channelTwo,
          publisher_channel_3: this.channelThree
        };

        // TODO: Do we want to handle attaching "component_metadata" or "event_metadata" to the events? To capture data about the request (ie, keyword or make/model requested)

        // "jfpc" components are always wrapped in a div with instance-id, so we can find the shadowDOM by that
        // otherwise we'll bind to the document (vue components aren't prefixed with "jfpc")
        document.querySelectorAll("jfpc-" + this.convertPascalToKebab(this.$options.name)).forEach(possibleComponent => {
          let thisShadowDOM = possibleComponent.shadowRoot;
          let thisInstanceElement = thisShadowDOM.querySelector("div[instance-id='" + this.instanceId + "']");
          if (thisInstanceElement) {
            this.shadowDOM = thisShadowDOM;
            this.domElement = possibleComponent;
          }
        });

        if(!this.shadowDOM) {
          this.shadowDOM = document;
          this.domElement = this.shadowDOM.querySelector("div[instance-id='" + this.instanceId + "']");
        }

        // Since "mounted" is reserved for PublisherBase, we need to individually call custom initialization methods for our extension & component
        this.initVisitorLocation()
          .then(() => this.extensionInit())
          .then(() => this.componentInit())
          .then(() => {
            this.jfpTrack("PageView");
            if (this.domain == "carscience.com") {
              window.addEventListener("blur", ()  => {
                setTimeout(() => {
                  if (document.activeElement instanceof HTMLIFrameElement) {
                    this.jfpTrack("ContentClick", { advertiser_account_id: 1051, event_value: 0.2 });
                  }
                }, 0);
              });
            }
          })
          .catch(e => {
            console.error("Mounted initialization hooks failed.", e);
            this.removeFromDOM = true;
          });
      })
      .catch(() => {
        console.error("Unauthorized Publisher Component usage.");
        this.removeFromDOM = true;
      });
  },
  methods: {
    extensionInit() {
      return new Promise((resolve) => {
        resolve();
      });
    },
    componentInit() {
      return new Promise((resolve) => {
        resolve();
      });
    },
    verifyComponentUsage() {
      let vm = this;

      return new Promise((resolve, reject) => {
        axios.post("https://api-v2.jumpfeed.com/network/publisher/auth", {
          publisher_account_id: vm.publisherAccountId
        })
          .then(function (response) {
            let token = response.data.data.token;
            axios.defaults.headers.common['Authorization'] = "Bearer " + token;
            window.jfp.init(token);
            resolve();
          })
          .catch(function (error) {
            console.log(error);
            reject();
          });
      });
    },
    generateInstanceId(random = true) {
      let prefix = this.id + "_" + this.componentPlacement;
      let sec = (Date.now() * 1000) + (Math.random() * 10000) + (Math.random() * 1000);
      let uniq = sec.toString(16).replace(/\./g, "").padEnd(14, "0");
      return prefix + uniq + (Math.trunc(Math.random() * 100000));
    },
    injectRobotoStylesheet() {
      const linkNode = document.createElement('link');
      linkNode.type = "text/css";
      linkNode.rel = "stylesheet";
      linkNode.href = "//fonts.googleapis.com/css?family=Roboto:300,400,500,700,900&display=swap";
      document.head.appendChild(linkNode);
    },
    initVisitorLocation(postalCode = "", country = "us") {
      return new Promise((resolve) => {
        if(postalCode && postalCode.length > 4) {
          let existingVisitorLocation = window.localStorage.getItem("jf-visitor-location") ? JSON.parse(window.localStorage.getItem("jf-visitor-location")) : this.visitorLocation;
          if(existingVisitorLocation && existingVisitorLocation.postalCode == postalCode) {
            this.setVisitorLocation(existingVisitorLocation.city, existingVisitorLocation.state, existingVisitorLocation.postalCode);
            resolve();
          }
          else {
            this.getPostalCodeLocationData(postalCode, (country && ["us","ca","au"].includes(country) ? country : "us"))
              .then(data => {
                this.setVisitorLocation(data.city, data.state, data.postal_code);
                resolve();
              })
              .catch(() => {
                this.lookupVisitorLocation()
                  .then(() => {
                    resolve();
                  });
              });
          }
        }
        else {
          this.lookupVisitorLocation()
            .then(() => {
              resolve();
            });
        }
      });
    },
    lookupVisitorLocation() {
      return new Promise((resolve) => {
        if(window.localStorage.getItem("jf-visitor-location")) {
          this.visitorLocation = JSON.parse(window.localStorage.getItem("jf-visitor-location"));
          resolve();
        }
        else {
          this.getVisitorGeolocationData()
            .then(geolocationData => {
              if(geolocationData) {
                if(["us", "ca", "au"].includes(geolocationData.country.toLowerCase())) {
                  if(geolocationData.postal_code.length > 0) {
                    if(geolocationData.city && geolocationData.state) {
                      this.setVisitorLocation(geolocationData.city, geolocationData.state, geolocationData.postal_code);
                    } else {
                      this.setVisitorLocation("", "", geolocationData.postal_code);
                    }
                  }
                }
              }
              resolve();
            })
            .catch(() => {
              resolve();
            });
        }
      });
    },
    setVisitorLocation(city, state, postalCode) {
      this.visitorLocation.city = city;
      this.visitorLocation.state = state;
      this.visitorLocation.postalCode = postalCode;

      let formatted = "";
      if(city.length == 0 && state.length == 0) {
        formatted = "Nationwide";
      } else if(city.length == 0 && state.length > 0) {
        formatted = state;
      } else {
        formatted = city + ", " + state;
      }
      this.visitorLocation.formatted = formatted;

      window.localStorage.setItem("jf-visitor-location", JSON.stringify(this.visitorLocation));
    },
    getPostalCodeLocationData(postalCode, country = "us") {
      return new Promise((resolve, reject) => {
        axios.get("https://api-v2.jumpfeed.com/network/publisher/geolocation/postal-code-location-data", {
          params: {
            postal_code: postalCode.replace(" ", ""),
            country_code: country
          }
        })
          .then(function (response) {
            let output = response.data.data;
            if(typeof output['city'] === "undefined" || typeof output['state'] === "undefined") {
              reject();
            }
            else {
              resolve(output);
            }
          })
          .catch(function (error) {
            console.log(error);
            reject();
          });
      });
    },
    getFullStateName(stateAbbreviation) {
      let statesMap = {
        "AL": "Alabama",
        "AK": "Alaska",
        "AZ": "Arizona",
        "AR": "Arkansas",
        "CA": "California",
        "CO": "Colorado",
        "CT": "Connecticut",
        "DE": "Delaware",
        "FL": "Florida",
        "GA": "Georgia",
        "HI": "Hawaii",
        "ID": "Idaho",
        "IL": "Illinois",
        "IN": "Indiana",
        "IA": "Iowa",
        "KS": "Kansas",
        "KY": "Kentucky",
        "LA": "Louisiana",
        "ME": "Maine",
        "MD": "Maryland",
        "MA": "Massachusetts",
        "MI": "Michigan",
        "MN": "Minnesota",
        "MS": "Mississippi",
        "MO": "Missouri",
        "MT": "Montana",
        "NE": "Nebraska",
        "NV": "Nevada",
        "NH": "New Hampshire",
        "NJ": "New Jersey",
        "NM": "New Mexico",
        "NY": "New York",
        "NC": "North Carolina",
        "ND": "North Dakota",
        "OH": "Ohio",
        "OK": "Oklahoma",
        "OR": "Oregon",
        "PA": "Pennsylvania",
        "RI": "Rhode Island",
        "SC": "South Carolina",
        "SD": "South Dakota",
        "TN": "Tennessee",
        "TX": "Texas",
        "UT": "Utah",
        "VT": "Vermont",
        "VA": "Virginia",
        "WA": "Washington",
        "WV": "West Virginia",
        "WI": "Wisconsin",
        "WY": "Wyoming"
      };
      return stateAbbreviation in statesMap ? statesMap[stateAbbreviation] : "Illinois";
    },
    getVisitorGeolocationData() {
      return new Promise((resolve, reject) => {
        axios({
          method: "get",
          url: "https://d33ok5lwvgxemb.cloudfront.net/",
          mode: "no-cors",
          transformRequest: [(data, headers) => { delete headers.common.Authorization; return data; }]
        })
          .then(function (response) {
            // TODO: Use below to log the geolocation for a visitor. (Can work similar to events w/ a queue if needed, for if visitorId not created/set yet)
            // window.jfp.setVisitorGeo(JSON.parse(response.headers['viewer-geolocation']))

            axios({
              method: 'post',
              url: 'https://api-v2.jumpfeed.com/network/publisher/geolocation/decrypt-data',
              data: {
                geolocation_encrypted: JSON.parse(response.headers['viewer-geolocation'])
              }
            })
              .then(function (response) {
                if (response.status === 200) {
                  resolve(response.data.data);
                } else {
                  resolve(null);
                }
              })
              .catch(function (error) {
                console.log(error);
                reject(error);
              });
          })
          .catch(function (error) {
            console.log(error);
            reject(error);
          });
      });
    },
    jfpTrack(eventName, eventData = {}) {
      let fullEventData = {
        ...this.publisherEventData,
        ...eventData
      };
      if(!this.disableEventsTracking || eventName === "PageView") {
        window.jfp.track(eventName, fullEventData);
      }
      this.$emit(this.convertPascalToKebab(eventName), fullEventData);
    },
    triggerNoContentLoaded(eventData) {
      this.jfpTrack("NoContentLoaded", eventData);
      if(eventData.advertiser_account_id) {
        sessionStorage.setItem(window.location.hostname + "-" + eventData.advertiser_account_id + "-noContentLoaded", "1");
      }
      this.removeFromDOM = true;
    },
    isMobileUserAgent() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    isFacebookUserAgent() {
      let ua = navigator.userAgent || navigator.vendor || window.opera;
      return (ua.indexOf("FBAN") > -1) || (ua.indexOf("FBAV") > -1);
    },
    convertPascalToKebab(string) {
      return string.replace(/([a-z0–9])([A-Z])/g, "$1-$2").toLowerCase();
    }
  }
}